[
  {
    "icon": "home",
    "path": "/",
    "title": "Tableau de board",
    "color": "#212121"
  },
  {
    "icon": "map",
    "path": "/travel",
    "title": "Voyages",
    "color": "#27ae60",
    "permissions": "TRAVEL_LIST",
    "children": [
      {
        "path": "",
        "title": "Consulter",
        "permissions": "TRAVEL_LIST"
      },
      {
        "path": "add",
        "title": "Ajouter",
        "permissions": "TRAVEL_ADD"
      },
      {
        "path": "data",
        "clickable": false,
        "title": "Données",
        "permissions": "TRAVEL_DATA_LIST",
        "children": [
          {
            "path": "member-allergy",
            "title": "Allergies"
          },
          {
            "path": "member-physical-condition",
            "title": "Conditions physiques"
          },
          {
            "path": "member-diet",
            "title": "Régimes alimentaires"
          },
          {
            "path": "member-nationality",
            "title": "Nationalités"
          },
          {
            "path": "update-text",
            "title": "Phrase de mise à jour"
          }
        ]
      }
    ]
  },
  {
    "icon": "mail",
    "path": "/mail",
    "title": "Email",
    "color": "#3498db",
    "permissions": "MAIL_LIST",
    "children": [
      {
        "path": "",
        "title": "Consulter",
        "permissions": "MAIL_LIST"
      },
      {
        "path": "template",
        "title": "Modèles",
        "permissions": "MAIL_TEMPLATE_LIST"
      },
      {
        "path": "layout",
        "title": "Mise en page",
        "permissions": "MAIL_LAYOUT_LIST"
      }
    ]
  },
  {
    "icon": "live_help",
    "path": "/support",
    "title": "Support",
    "color": "#e74c3c",
    "permissions": "SUPPORT_LIST"
  },
  {
    "icon": "sms",
    "path": "/sms",
    "title": "Sms",
    "color": "#8e44ad",
    "permissions": "SMS_LIST",
    "children": [
      {
        "path": "",
        "title": "Consulter",
        "permissions": "SMS_LIST"
      },
      {
        "path": "add",
        "title": "Envoyer",
        "permissions": "SMS_ADD"
      },
      {
        "path": "template",
        "title": "Modèles",
        "permissions": ["SMS_TEMPLATE_LIST"]
      },
      {
        "path": "layout",
        "title": "Mise en page",
        "permissions": ["SMS_LAYOUT_LIST"]
      }
    ]
  },
  {
    "icon": "people",
    "path": "/user",
    "title": "Utilisateurs",
    "color": "#e67e22",
    "permissions": ["USER_LIST"],
    "children": [
      {
        "path": "",
        "title": "Consulter",
        "permissions": ["USER_LIST"]
      },
      {
        "path": "add",
        "title": "Ajouter",
        "permissions": ["USER_ADD"]
      },
      {
        "path": "group",
        "title": "Groupes",
        "permissions": ["USER_GROUP_LIST"],
        "children": [
          {
            "path": "",
            "title": "Consulter",
            "permissions": ["USER_GROUP_LIST"]
          },
          {
            "path": "add",
            "title": "Ajouter",
            "permissions": ["USER_GROUP_ADD"]
          }
        ]
      }
    ]
  },
  {
    "icon": "thermostat",
    "clickable": false,
    "path": "/weather",
    "title": "Météo",
    "color": "#27ae60",
    "permissions": "WEATHER",
    "children": [
      {
        "path": "data",
        "clickable": false,
        "title": "Données",
        "children": [
          {
            "path": "condition",
            "title": "Conditions",
            "permissions": "WEATHER_DATA_CONDITION_LIST"
          }
        ]
      }
    ]
  },
  {
    "icon": "settings",
    "path": "/parameter",
    "title": "Paramètres",
    "color": "#2c3e50",
    "permissions": "PARAMETER_LIST"
  }
]
